import { render, staticRenderFns } from "./Interregional_Analysis_Materials_Right.vue?vue&type=template&id=5a78e0f4&scoped=true"
import script from "./Interregional_Analysis_Materials_Right.vue?vue&type=script&lang=js"
export * from "./Interregional_Analysis_Materials_Right.vue?vue&type=script&lang=js"
import style0 from "./Interregional_Analysis_Materials_Right.vue?vue&type=style&index=0&id=5a78e0f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a78e0f4",
  null
  
)

export default component.exports